import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "titlePages" }
const _hoisted_2 = { class: "pl-4" }
const _hoisted_3 = { class: "pl-4" }
const _hoisted_4 = { class: "pl-4" }
const _hoisted_5 = { class: "pl-4" }

import { ref, Ref, onMounted }  from 'vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import StatisticsComponent from '@/components/GestorHCGLink/dialogs/statisticsComponent.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
import { HEADER, ALLHEADER }    from '@/interfaces/SmartLink/Tables';
import { ALLDATAINFO, ENLACES, LASTENLACEINFO, TABLEINFO } from '@/interfaces/GestorHCGLINK/Equips';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from '@/constants/labels';

/********************************
 *********** SERVICES ***********
 *******************************/
import { getItemsTablesGestor, getLast30DaysLTEGestor, getLastDatesLTEGestor, getMaxDatesLTEGestor } from '@/services/Gestor/Gestor';







export default /*@__PURE__*/_defineComponent({
  __name: 'StatisticsView',
  setup(__props) {

const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ********** COMPONENTS **********
 *******************************/
const { xs } = useDisplay();

/********************************
 ********** INTERFACES **********
 *******************************/
const sendData:Ref<ENLACES[]> = ref([])



const finalInfoData:Ref<LASTENLACEINFO> = ref({})
const finalInfoData30Days:Ref<ALLDATAINFO> = ref({});
const selectedIP        = ref('');
const selectedNAME      = ref('');
const arrayDates:Ref<string[]>   = ref([]);
// const showDataTable     = ref(false);

async function getMaxDatesLTE() {

    const allData = await getMaxDatesLTEGestor()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        arrayDates.value = allData.data
    }
}



async function getLastDatesLTE() {
    let params = {
        dates  : arrayDates.value
    }    
    sendData.value = [];    

    const allData = await getLastDatesLTEGestor(params)

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        finalInfoData.value = allData.data
    }
}

async function getAllDaysLTE() {

    const allData = await getLast30DaysLTEGestor()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        finalInfoData30Days.value = allData.data
    }
}

function showDataInfo(item:TABLEINFO) {
    sendData.value = [];
    sendData.value = finalInfoData.value[item.ip] ? finalInfoData.value[item.ip] : [] ;
    selectedIP.value = item.ip;
}

const finalRXBYTES:Ref<number[][]> = ref([]);
const finalTXBYTES:Ref<number[][]> = ref([]);

/**
 * Control del dialog de estadísticas
 */
const dialog = ref(false);

/**
 * Mostrar dialog con estadísticas
 * @param name Nombre del equipo
 */
function showDialog(name:string) {
    let selectedInfo = finalInfoData30Days.value[selectedIP.value][name]
    selectedNAME.value = name
    finalRXBYTES.value = selectedInfo.rxbytes;
    finalTXBYTES.value = selectedInfo.txbytes;
    dialog.value = true;
}

/**
 * Cerrar dialog
 */
function closeDialog(){
    dialog.value = false;
}



/**
 * Headers de la tabla principal
 */
const HEADERS__PRIMARY_TABLE:ALLHEADER = {
    header : [
        { text: 'IP Address',   value: "ip",            sortable: true },
        { text: 'Nombre',       value: "name",          sortable: true },
        { text: 'Tipo',         value: "tipo",          sortable: true },
        { text: 'Subitpo',      value: "subtipo",       sortable: true },
        { text: 'Mark',         value: "marca",         sortable: true },
    ]
};

/**
 * Headers de la tabla principal, inicia en array vacío
 */
const headers:Ref<HEADER[]>     = ref([]);

// Asignar los headers de la tabla principal
headers.value = HEADERS__PRIMARY_TABLE['header'];


/**
 * Lista de items de la tabla principal
 */
const itemsLTE: Ref<TABLEINFO[]> = ref([]);

/**
 * Traer datos básico de la tabla principal llamando a la api 'getIPLTE'
 */
const getItems = async() => {

    const allData = await getItemsTablesGestor()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        itemsLTE.value = allData.data
    }
}

onMounted(async () => {
    getItems() 
    await getAllDaysLTE();
    await getMaxDatesLTE();
    await getLastDatesLTE();
})


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_sheet, {
      color: "bgtopology",
      class: "ma-4 defaultCard"
    }, {
      default: _withCtx(() => [
        (itemsLTE.value.length > 0)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              class: "ma-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  class: "pa-0 mb-4",
                  cols: "12",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('labels.statistics')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "8" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_EasyDataTable, {
                      "show-index": "",
                      "table-class-name": "customize-table",
                      headers: headers.value,
                      items: itemsLTE.value,
                      "rows-per-page": 10,
                      "hide-footer": false,
                      onClickRow: showDataInfo
                    }, null, 8, ["headers", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    (sendData.value.length > 0)
                      ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sendData.value, (item, i) => {
                              return (_openBlock(), _createBlock(_component_v_col, {
                                key: i,
                                cols: "6",
                                class: "pa-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_sheet, {
                                    color: "transparent",
                                    class: "cardStatisticsLTE py-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        class: "ma-0",
                                        justify: "space-around"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(item.ifDescr), 1),
                                          _createVNode(_component_v_icon, {
                                            icon: "mdi-chart-bell-curve-cumulative",
                                            size: "small",
                                            onClick: ($event: any) => (showDialog(item.ifDescr))
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createElementVNode("table", null, [
                                        _createElementVNode("tr", null, [
                                          _cache[1] || (_cache[1] = _createElementVNode("td", null, "MTU (Bytes)", -1)),
                                          _createElementVNode("td", _hoisted_2, _toDisplayString(item.ifMtu), 1)
                                        ]),
                                        _createElementVNode("tr", null, [
                                          _cache[2] || (_cache[2] = _createElementVNode("td", null, "Speed (Mbps)", -1)),
                                          _createElementVNode("td", _hoisted_3, _toDisplayString(parseInt(item.ifSpeed)/1000000), 1)
                                        ]),
                                        _createElementVNode("tr", null, [
                                          _cache[3] || (_cache[3] = _createElementVNode("td", null, "RX (MBytes)", -1)),
                                          _createElementVNode("td", _hoisted_4, _toDisplayString(item.RXBytes), 1)
                                        ]),
                                        _createElementVNode("tr", null, [
                                          _cache[4] || (_cache[4] = _createElementVNode("td", null, "TX (MBytes)", -1)),
                                          _createElementVNode("td", _hoisted_5, _toDisplayString(item.TXBytes), 1)
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              justify: "center",
              class: "ma-4"
            }, {
              default: _withCtx(() => [
                _createVNode(Prog_circular)
              ]),
              _: 1
            }))
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
      width: "85%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "card_dialog",
          color: "background"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "ma-0",
              justify: "space-between",
              style: {"align-items":"self-end !important"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "10" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(_unref(xs) ? 'textDashboard' : 'subtitleDashboard')
                    }, _toDisplayString(selectedIP.value) + " - " + _toDisplayString(selectedNAME.value), 3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      icon: "mdi-close",
                      variant: "plain",
                      onClick: closeDialog
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider, { class: "mt-7" }),
            _createVNode(_component_v_sheet, { color: "transparent" }, {
              default: _withCtx(() => [
                _createVNode(StatisticsComponent, {
                  rxbytes: finalRXBYTES.value,
                  txbytes: finalTXBYTES.value
                }, null, 8, ["rxbytes", "txbytes"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})